import axios from "axios";
import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";
import * as config from "../config";

export const requestMoreRegion = async (payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_USER_REGION_REQUEST, payload, token);
  return res;
};

export const GetUserRegionsRequestData = async (id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_USER_REGION_REQUEST + id, token);
  return res;
};

export const InsertUserRegionsApprovalData = async (payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.INSERT_REGION_APPROVAL, payload, token);
  return res;
};

export const Clinical_Support_Request = async (payload) => {
  let token = localStorage.getItem("token");

  let res = Services.POSTFORMDATA(
    Url.CLINICAL_SUPPORT_REQUEST,
    payload,
    token
  );
  return res;
};
